import {request} from "network/request"
import Qs from 'qs'

//获得所有用户和组的名称列表
export function usersAndGroupsList(userInfo){
  var userInfoData = Qs.stringify(userInfo);
  console.log(userInfoData);
  return request({
      method:"post",
      'Content-Type':'application/x-www-form-urlencoded',
      url:"Get_alluserAndGroup_list.php",
      data:userInfoData
  })
}

//获得一个用户或组的权限情况
export function getAuthority(userInfo){
  var userInfoData = Qs.stringify(userInfo);
  console.log(userInfoData,'user');
  return request({
      method:"post",
      'Content-Type':'application/x-www-form-urlencoded',
      url:"Get_a_quanxian.php",
      data:userInfoData
  })
}

//上传更改用户或组的权限
 export function changeAuthority(userInfo){
    var userInfoData = Qs.stringify(userInfo);
    console.log(userInfoData);
    return request({
        method:"post",
        'Content-Type':'application/x-www-form-urlencoded',
        url:"Update_a_quanxian.php",
        data:userInfoData
    })
 }